export default [
    {
        "titleId": "singleGame",
        "title": "Single Game",
        "tooltip": "Play select individual games without saving data.",
        "view": "/play_game?single_game_id=ALL",
        "icon_data": {
            "path": "single-game.svg"
        },        
        "color": "#f04c58",
        "is_external": true,
        "bottom_title": false,
        "border_radius": "40px 7px 40px 40px",
        "card_class": "red"
    }
]


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/button-config.js